export const USER_REGISTRATION = 'userRegistration'
export const UPDATE_USER_PROFILE = 'updateUserProfile'
export const GET_USER_MAIL = 'getUserMail'
export const UPDATE_USER_MAIL = 'updateUserMail'
export const GET_USER_MAIL_CHANGE_ADDRESS = 'getUserMailChangeAddress'
export const USER_LOGIN = 'userLogin'
